import { TableCell } from './table-cell';

export class TableTd extends TableCell {

    dataType?: 'STRING' | 'DATE' | 'NUMBER' | 'BUTTON' | 'ANY' | 'FILE'| 'BOOLEAN'|'INPUT';          // date ? string ? number ?

    constructor(columnId: string = null) {
        super();
        this.dataType = 'STRING';
        this.columnId = columnId;
    }
}
